import { render, staticRenderFns } from "./loginScreen.vue?vue&type=template&id=44018710"
import script from "./loginScreen.vue?vue&type=script&lang=js"
export * from "./loginScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports